import React from 'react'
import { Box, Flex } from '@chakra-ui/react'

interface PropsType {
  length: number
  page: number
  onClick: (num: number) => void
}

const PaginationCircle = ({ length, page, onClick }: PropsType) => {
  const displayCircles = () => {
    const arr = Array.from({ length }, (v: number, k: number) => k + 1)
    return arr.map((v, k) => {
      return (
        <Box
          key={k}
          w={page === v ? 3.5 : 2.5}
          h={page === v ? 3.5 : 2.5}
          bg={page === v ? 'white' : 'bgBold'}
          borderRadius={'50%'}
          border={page === v ? '2px solid' : 'none'}
          borderColor={page === v ? 'bgBold' : 'white'}
          cursor={'pointer'}
          transition={'ease-inb'}
          onClick={() => {
            onClick(v)
          }}
        />
      )
    })
  }

  if (!length || length <= 0) return null

  return (
    <Flex
      w={'100%'}
      gap={2}
      alignItems={'center'}
      justifyContent={'center'}
      mt={5}
    >
      {displayCircles()}
    </Flex>
  )
}

export default PaginationCircle
